<template>
  <modal
    width="68"
    title="Process Return"
    v-loading="loading"
    :show-modal="showModal"
    @close-modal="$emit('close-modal')"
  >
    <div class="flex items-center mt-6">
      <div class="single-option">
        <label for="delivery" class="radio-label">
          <input
            type="radio"
            v-model="returnType"
            value="Delivery"
            id="delivery"
            name="routeEnd"
          />
          Deliver to my Address
          <span></span>
        </label>
      </div>

      <div class="single-option">
        <label id="pickup" class="radio-label">
          <input
            type="radio"
            v-model="returnType"
            value="pickUp"
            id="pickup"
            name="routeEnd"
          />
          Pick-up from Terminal
          <span></span>
        </label>
      </div>
    </div>

    <div v-if="returnType === 'Delivery'" class="mt-4">
      <label>Return Address:</label>

      <vue-google-autocomplete
        id="map"
        ref="shipperAddress"
        classname="input"
        placeholder="Enter address"
        v-on:placechanged="getAddress"
      >
      </vue-google-autocomplete>
    </div>
    <div v-else class="mt-4">
      <label for="">Return Terminal:</label>
      <el-select
        filterable
        disabled
        v-model="terminal"
        placeholder="Select Return Terminal"
      >
        <el-option
          v-for="location in locations"
          :key="location.id"
          :label="location.locationName"
          :value="location.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="flex items-center my-6 w-11/12">
      <div class="text-sm col-md-6 col-12">
        <label>Preferred Delivery</label>
        <el-date-picker
          type="date"
          class="w-full"
          v-model="deliveryDate"
          placeholder="Pick a time"
        >
        </el-date-picker>
      </div>
      <div class="text-sm col-md-6 col-12 flex justify-between">
        <div class="col-5">
          <label class="opacity-50">FROM</label>
          <el-time-picker
            type="date"
            v-model="deliveryTime_1"
            placeholder="Pick a time"
          >
          </el-time-picker>
        </div>
        <div class="col-5">
          <label class="opacity-50">TO</label>
          <el-time-picker
            type="date"
            v-model="deliveryTime_2"
            placeholder="Pick a time"
          >
          </el-time-picker>
        </div>
      </div>
    </div>

    <div v-if="returnType ==='Delivery'">
      <b class="pb-3">Select Shipping Service</b>
      <div>
        <div class="overflow-auto whitespace-no-wrap">
          <div
            v-for="(item, index) in shippingService"
            class="mr-2 my-2 zoom"
            :key="index + 1"
            @click="shippingServiceId = item.id"
            :class="[shippingServiceId == item.id ? 'active-tab' : 'dull-tab']"
          >
            <p class="opacity-75">{{ item.orgName ? item.orgName : "N/A" }}</p>
            <p class="opacity-50 py-3 text-sm">
              {{
                (item.takeOffLocation || "N/A") +
                " - " +
                (item.arrivalLocation || "N/A")
              }}
            </p>
            <p class="mt-1">
              Arrives {{ item.arrivalTime ? item.arrivalTime : "N/A" }}
            </p>
            <p class="mt-3 opacity-50">
              {{ item.shippingMethod ? item.shippingMethod : "N/A" }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <b class="pb-3">Select Shipping Service</b>
      <div>
        <div class="overflow-auto whitespace-no-wrap">
          <div
            v-for="(item, index) in shippingService"
            class="mr-2 my-2 zoom"
            :key="index + 1"
            @click="shippingServiceId = item.id"
            :class="[shippingServiceId == item.id ? 'active-tab' : 'dull-tab']"
          >
            <p class="opacity-75">{{ item.orgName ? item.orgName : "N/A" }}</p>
            <p class="opacity-50 py-3 text-sm">
              {{
                (item.takeOffLocation || "N/A") +
                " - " +
                (item.arrivalLocation || "N/A")
              }}
            </p>
            <p class="mt-3 opacity-50">
              {{ item.shippingMethod ? item.shippingMethod : "N/A" }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pb-10 flex flex-wrap">
      <label class="w-full mt-4">Select Costs</label>
      <div class="overflow-auto whitespace-no-wrap">
        <div
          v-for="(item, index) in Object.keys(cost)"
          class="mr-3 my-2 zoom"
          :key="index + 1"
          @click="setCostEngine(index + 1)"
          :class="[costId == index + 1 ? 'active-tab' : 'dull-tab']"
        >
          <p class="mt-3 uppercase text-base">
            {{ item.replace("Cost", "") }}
          </p>
          <p class="font-bold text-2xl pt-3">
            <Sup>₦</Sup
            >{{ amountFomatter(Object.values(cost)[index].totalCost) }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between">
      <button @click="$emit('close-modal')">Cancel</button>
      <el-dropdown
        class="h-full text-black"
        :class="[!procedToPayment ? 'opacity-50' : 'opacity-100']"
      >
        <button
          :disabled="!procedToPayment"
          class="payment-assignqs h-full font-semibold rounded flex items-center p-2 bg-primary-yellow"
        >
          <span class="mr-3 pr-2">Make Payment</span>

          <arrow-down-filled />
        </button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <button>Charge Card</button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button>Charge Wallet</button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button @click="showPaymentModalFunc">Pay with Paystack</button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <PaymentModal
      @close-modal="showPaymentModal = false"
      :show-modal="showPaymentModal"
      :total="costEngine.totalCost ? costEngine.totalCost : '10'"
      :costEngine="costEngine"
      :shippingId="booking.id"
      @process-paystack="refreshPage()"
    />
  </modal>
</template>

<script>
import PaymentModal from "./PaymentModal.vue";
import moment from "moment";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  components: { PaymentModal, VueGoogleAutocomplete },
  mounted() {
    this.getTerminals();
    this.getShippingService();

    this.terminal = this.booking.dropOff

    if (this.dropOff) {
      this.getShippingServicesByTerminal(
        this.dropOff,
        this.pickUp
      );
    }
  },
  computed: {
    dropOff(){
        let drop = Math.min(...this.takeOffLocation.map((dropOff) => {
          return dropOff.lat
        }))
        return this.takeOffLocation.filter(lat => lat.lat == drop)[0].id
    },
    pickUp(){
      return this.terminal
    },
    user() {
      return JSON.parse(localStorage.getItem("loggedInUser"));
    },
    procedToPayment() {
      return this.costId && this.shippingServiceId;
    },
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
    costPayload() {
      return {
        shippingId: this.booking.id,
        shippingServiceId: this.shippingServiceId,
        type: "single",
      };
    },
    deliveryTimeFormat() {
      return [
        this.deliveryTime_1
          ? moment(this.deliveryTime_1).format("HH:MM")
          : null,
        this.deliveryTime_2
          ? moment(this.deliveryTime_2).format("HH:MM")
          : null,
      ];
    },
    payload() {
      return {
        transaction: {
          status: "paid",
          userId: this.user?.id,
          orgId: this.user.orgId,
          totalValue: this.costEngine?.totalCost,
          paymentStatus: "paid",
          breakDown: {
            vat: 0,
            insuranceFee: 0,
            handlingCharges: 0,
          },
          amount_paid: this.costEngine?.totalCost,
          payment_type: "card",
          shippingId: this.shipping?.id,
          userType: "private",
        },
        shipperLocationId: this.shipping?.shipperLocationId,
        shippingMethod: "drop-off",
        dropOff:this.terminal,
        returnOrForwardingAddress: this.address.name,
        deliveryDays: this.deliveryDate
          ? moment(this.deliveryDate).format("YYYY-MM-DD")
          : undefined,
        deliveryTime: this.deliveryTimeFormat,
      };
    },
  },
  data() {
    return {
      locations: [],
      returnType: "Delivery",
      loading: false,
      method: "Deliver to my Address",
      address: {
        name: "",
        lat: 0.0,
        lng: 0.0,
      },
      takeOffLocation:[],
      shippingService: [],
      shippingServiceId: undefined,
      deliveryDate: "",
      deliveryTime_1: "",
      deliveryTime_2: "",
      cost: {},
      shippingInformation: [],
      costEngine: {},
      costId: undefined,
      terminal: "",
      showPaymentModal: false,
      shippingServiceTerminal: [],
    };
  },

  watch: {
    cost(val){
this.cost = val
    },
    shipping() {
      this.getShippingService();
    },
    shippingServiceId() {
      this.getCostEngine();
    },
    dropOff(dropOff) {
      if (this.shippingInformation.pickUp) {
        this.getShippingServicesByTerminal(
          dropOff,
          this.shippingInformation.pickUp
        );
      }
    },
    pickUp(pickUp) {
      if (this.dropOff) {
        this.getShippingServicesByTerminal(
          this.dropOff,
          pickUp
        );
      }
    },
  },

  methods: {
    refreshPage(){
      this.$emit("hide-return")
      this.$router.push("/3pl/dashboard")

    },
    getAddress(addressData) {
      this.address.name = addressData.route;
      this.address.lat = addressData.latitude;
      this.address.lng = addressData.longitude;
      this.consignee.country = this.countries[0];
    },
    setCostEngine(index) {
      this.costId = index;
      this.costEngine = { ...Object.values(this.cost)[index - 1] };
    },
    showPaymentModalFunc() {
      this.$store.dispatch("saveProcessReturnDetails", this.payload);
      this.showPaymentModal = true;
    },
    async getShippingService() {
      try {

        const shipperLocationId = this.booking.shipperLocationId
        const consigneeLocationId = this.booking.consigneeLocationId

        const response = await this.$_getShippingServicesByRoute(
          shipperLocationId,
          consigneeLocationId
        );

        this.shippingService = response.data.data.shippingServices;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getShippingServicesByTerminal(dropOff, pickUp) {
      try {
        console.log(dropOff, pickUp);

        const response = await this.$_getShippingServiceByTerminal(
          dropOff,
          pickUp
        );
        this.shippingServiceTerminal = response.data.data.shippingServices;
        console.log(JSON.stringify(this.shippingServiceTerminal, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },
    async getTerminals() {
      let shipperAdd = this.booking.shipperlocation.address;
      let consigneeAdd = this.booking.consigneelocation.address;
      const payload = {
        orgId: this.booking.organizationId,
        arrivalLocation: {
          lat: consigneeAdd.lat,
          lng: consigneeAdd.lng,
        },
        takeOffLocation: {
          lat: shipperAdd.lat,
          lng: shipperAdd.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);
        this.locations = response.data.data.arrivalLocation;
        this.takeOffLocation = response.data.data.takeOffLocation;
        
      } catch (error) {
        this.handleError(error);
      }
    },
    getCostEngine() {
      try {
        this.$_getCostEngine(this.costPayload).then((response) => {
          this.cost = response.data.data;
        });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.single-option {
  @apply mr-4;
}
.zoom {
  transition: 0.6s;
  display: inline-block;
  margin-left: 5px;
  transform: scale(1);
}
.zoom:hover {
  transform: scale(1.03);
}
.dull-tab {
  @apply p-3 border-2 border-gray-400 bg-gray-100 text-center py-8 duration-300;
  width: 230px;
}
.active-tab {
  width: 230px;
  @apply p-3 border-2 border-gray-400 bg-primary-navy text-white text-center py-8 duration-300;
}
</style>
